module.exports = __webpack_public_path__ + "img/school-bus.8f84eab8.svg";